import produce from "immer";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";
import { startEditAlert } from "../../actions/alertAction";
import {
  startLoadFormToProtoTypePreview,
} from "../../actions/formListAction";
import { startEditModal } from "../../actions/modalAction";
import { Form } from "../../models/formModel";
import { AppState } from "../../reducers/rootReducer";
import protoTypeService from "../../services/prototypeService";
import RowElement from "../elementComponents/RowElement";
import formCss from "../preview/utils/formCss";
import ModalComponent from "../util/modal";
import "./prototypePreviewComponent.scss";
import { getViewRemark } from "../../selectors/appSelectors";
import { Tooltip } from "react-tippy";
import Switch from "react-switch";
import { startEditSession } from "../../actions/sessionListAction";

type TParams = { id: string };

const PrototypePreviewComponent = ({ match }: RouteComponentProps<TParams>) => {
  const dispatch = useDispatch();
  let emptyFormList: Form[] = [];
  const [formList, setFormList] = useState(emptyFormList);
  const [index, setIndex] = useState(0);
  const [isLoading, setLoding] = useState(false);
  const [selectedFormId, setSelectedFormId] = useState("");
  const [pageName, setPageName] = useState("");
  // const rowState = useSelector(getAllRows);
  const rowState = useSelector((state: AppState) => state.rowList);
  const modalState = useSelector((state: AppState) => state.modal);
  const formState = useSelector((state: AppState) => state.alert);
  const sessionState = useSelector((state: AppState) => state.session);
  const viewRemark = useSelector(getViewRemark);

  const viewRemarks = () => {
    const newSession = produce(sessionState, (draft) => {
      draft.viewRemark = !draft.viewRemark;
    });
    dispatch(startEditSession(newSession));
  };

  useEffect(() => {
    async function loadProtoType() {
      setLoding(true);
      const response = await protoTypeService.getProtoType({
        id: match.params.id,
      });
      console.log(response.data.data);
      if (response.data.data.formList.length > 0) {
        // for(let i = 0; i > response.data.data.formList.length; i++ ){
        //   if(response.data.data.formList[i].id !== "Start" && response.data.data.formList[i].id !== "End"){
        //     setFormList(oldArr => [...oldArr , response.data.data.formList[i]]);
        //   }
        //   console.log(response.data.data.formList)
        // }
        // setFormList(response.data.data.formList);
        const formArr: Form[] = response.data.data.formList.filter(
          (form: Form) => {
            return form.id !== "Start" && form.id !== "End";
          }
        );
        setFormList(formArr);
        dispatch(startLoadFormToProtoTypePreview(formArr[0]));

        // dispatch(setRow(response.data.data.rowList));
        // dispatch(setSection(response.data.data.sectionList));
        // dispatch(setElement(response.data.data.elementList));
        // dispatch(setTab(response.data.data.tabList));
        setIndex(0);
        const newModalState = produce(modalState, (draft) => {
          draft.show = false;
        });
        dispatch(startEditModal(newModalState));
        const newAlertState = produce(formState, (draft) => {
          draft.id = formArr[0].id;
        });
        dispatch(startEditAlert(newAlertState));
        setPageName(formArr[0].name);
      }
      setLoding(false);
    }

    loadProtoType();
  }, []);

  const renderRowList = () => {
    let rowListBySelectedFrom = rowState.filter((row) => {
      // if (row.type === "form" && row.formId === formState.id) return row;
      return row.type === "form" && row.formId === formState.id;
    });
    console.log(rowListBySelectedFrom);
    return rowListBySelectedFrom.map((row, i) => {
      return <RowElement row={row} index={i} isPreview={true} />;
    });
  };

  const clickNext = () => {
    setLoding(true);
    dispatch(startLoadFormToProtoTypePreview(formList[index + 1]));
    const newAlertState = produce(formState, (draft) => {
      draft.id = formList[index + 1].id;
    });
    dispatch(startEditAlert(newAlertState));
    setIndex(index + 1);
    setLoding(false);

    setPageName(formList[index + 1].name);
  };

  const clickPrevious = () => {
    setLoding(true);
    dispatch(startLoadFormToProtoTypePreview(formList[index - 1]));
    const newAlertState = produce(formState, (draft) => {
      draft.id = formList[index - 1].id;
    });
    dispatch(startEditAlert(newAlertState));
    setIndex(index - 1);
    setLoding(false);
    setPageName(formList[index - 1].name);
  };

  const styleObj = () => {
    const forms = formList.filter((form) => {
      return form.id === formState.id;
    });

    return formCss(forms);
  };

  return (
    <>
      {formList.length > 0 && (
        <div className="container-fluid full-screen" style={{ ...styleObj() }}>
          <div className="d-flex bd-highlight">
            <div className="p-2 d-flex align-items-center">
              {index > 0 && (
                <>
                  <i
                    id="preIco"
                    onClick={() => clickPrevious()}
                    className="fa fa-arrow-left"
                  ></i>
                  <label htmlFor="preIco" className="mb-0" onClick={() => clickPrevious()}>
                    Previous
                  </label>
                </>
              )}
            </div>
            <div className="p-2 w-100 text-center">{pageName}</div>
            <div className="p-2 d-flex align-items-center">
              {index < formList.length - 1 && (
                <>
                  <label htmlFor="nxtIco" className="mb-0" onClick={() => clickNext()}>
                    Next
                  </label>
                  <i
                    id="nxtIco"
                    onClick={() => clickNext()}
                    className="fa fa-arrow-right"
                  ></i>
                </>
              )}
            </div>
          </div>
          <div className=" row-list">{!isLoading && renderRowList()}</div>
          <ModalComponent
            isShow={modalState.show}
            properties={modalState.properties}
            formId={modalState.id}
          />
          {/* <div className="row">
            <div className="container prototype-arrow-buttons">
              <div className="row ">
                {index > 0 && (
                  <i onClick={() => clickPrevious()} className="fa fa-arrow-left" >
                    Previous
                  </i>
                )}
                {index < formList.length - 1 && (
                  <i onClick={() => clickNext()} className="fa fa-arrow-right" >
                    Next
                  </i>
                )}
              </div>
            </div>
          </div> */}
        </div>
      )}
      {formList.length == 0 && (
        <div>
          <h5>No Prototype Preview for link {match.url}</h5>
        </div>
      )}
    </>
  );
};

export default PrototypePreviewComponent;
